export function OutlineDisponibilidadIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.17996 13.8308C4.79018 13.2357 3.01465 11.0715 3.01465 8.49456C3.01465 5.46175 5.4764 3 8.51401 3C11.0909 3 13.2552 4.77074 13.8502 7.16051"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07153 9.10851L7.61193 10.5673C8.4757 9.70355 10.9567 7.27539 10.9567 7.27539"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5152 20.9948C18.5524 20.9948 21.0146 18.5327 21.0146 15.4955C21.0146 12.4582 18.5524 9.99609 15.5152 9.99609C12.478 9.99609 10.0159 12.4582 10.0159 15.4955C10.0159 18.5327 12.478 20.9948 15.5152 20.9948Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3987 13.3789L17.6264 17.6066"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6264 13.3789L13.3987 17.6066"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
